import { createStore } from 'redux';

// We need very simple store only for running FeedPage
export default createStore((state, action) => state);
